export * from './completion';
export { registrationCompletionI18n } from './completion.i18n';
